

export default {
    methods:{
        disPlayOrNot(dataObj,dataTxtLenght,dataVisible){
            if (dataObj && dataTxtLenght>0 ) {
                if(this.userIsAdmin){
                    // console.log('userIsAdmin ==> return true')
                    return true
                }
                // console.log('dataVisible ==> return '+dataVisible)
                return  dataVisible
            }

            // console.log(' return False ')
            return false

        }
    },



}